module.exports = __webpack_public_path__ + "static/img/110119.c9921bfb.png";